var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titlebar'),_c('div',{staticClass:"cards"},[_c('Card',[_c('h2',[_vm._v("Competition entries")]),_c('EventEntriesForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }